<script>
	import appConfig from '@src/app.config'
	import Layout from '@layouts/_main'
	import PageHeader from '@components/page-header'

	import { customerApi } from '@router/apiFiles/customerApi'
	
	export default {
		page: {
			title: 'Update Customer',
			meta: [{ name: 'description', content: appConfig.description }],
		},
		components: {
			Layout,
			PageHeader,
		},
		data() {
			return {
                items: [
                    {
                        text: 'OnBoard',
                        href: '/',
                    },
                    {
                        text: 'Customers',
                        href: '/',
                    },
                    {
                        text: 'Update',
                        active: true,
                    },
				],
                isBusy: true,
                customer: {},
			}
		},
        props: {
            number: {
                type: String,
                default: null
            }
		},
		computed: {
			orderIsValid() {
            },
        },
		mounted() {
			this.fetchData().catch(error => {
				console.error(error)
			})
		},
		methods: {
			async fetchData() {
				var self = this;
				self.isBusy = true;
				customerApi.getCustomer({ id: self.$route.params.id })
					.then(function (data) {
						self.customer = data;
						self.isBusy = false;
					});					
			},		
            save() {
				var self = this;
				self.isBusy = true;
				self.show = false;
				customerApi.updateCustomer({ id:self.customer.id, name:self.customer.name, document:self.customer.document, corporateName:self.customer.corporateName, tradeName:self.customer.tradeName, note:self.customer.note, alertEmail:self.customer.alertEmail, techEmail:self.customer.techEmail, techManager:self.customer.techManager, techPhone:self.customer.techPhone })
					.then(function (data) {
						self.isBusy = false;
						self.$router.push('/searchcustomers');
					});
			},

		}
	}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<b-overlay :show="isBusy">
			<div class="row">

				<div class="col-lg-6">
					<div class="card">
						<div class="card-body">
							<h4 class="header-title mb-3">Update Customer</h4>
														
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Name</h5>
										<b-form-input v-model="customer.name"></b-form-input>
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Document</h5>
										<b-form-input v-model="customer.document"></b-form-input>
									</div>
								</div>								
							</div>
							
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Corporate Name</h5>
										<b-form-input v-model="customer.corporateName"></b-form-input>
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Trade Name</h5>
										<b-form-input v-model="customer.tradeName"></b-form-input>
									</div>
								</div>								
							</div>
							
							<div class="row">
								<div class="col-lg-12">
									<div class="mb-4">
										<h5 class="mt-0">Note</h5>
										<textarea class="form-control bg-soft-warning" rows="6" v-model="customer.note"></textarea>
									</div>
								</div>
							</div>							
							
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Alert email</h5>
										<b-form-input v-model="customer.alertEmail"></b-form-input>
									</div>
								</div>
							</div>							
							
							<div class="row">
								<div class="col-lg-4">
									<div class="mb-4">
										<h5 class="mt-0">Tech Manager</h5>
										<b-form-input v-model="customer.techManager"></b-form-input>
									</div>
								</div>
								<div class="col-lg-5">
									<div class="mb-4">
										<h5 class="mt-0">Tech Email</h5>
										<b-form-input v-model="customer.techEmail"></b-form-input>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="mb-4">
										<h5 class="mt-0">Tech Phone</h5>
										<b-form-input v-model="customer.techPhone"></b-form-input>
									</div>
								</div>								
							</div>							
							
							<div class="row">
								<div class="col-lg-12">
									<a href="javascript: void(0);" @click="save()" class="btn btn-primary btn-sm float-right">Save<i class="uil uil-edit ml-1"></i></a>
								</div>
							</div>

						</div>
					</div>
				</div>
				
			</div>


		</b-overlay>
	</Layout>
</template>
